/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.leave-requests.leave-requests'},
});

const LeaveRequestsItem = () => (
  <RouteLinkItem
    route="midas/settings/leave-requests/leave-request-managers"
    title={messages.title}
  />
);

export default LeaveRequestsItem;
